import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Dialog backdrop: emits (backdropClose) for a click that both started and ended on the backdrop
 * itself. A text selection dragged out of the dialog ends with a click on the backdrop; that one
 * must not close the dialog.
 */
@Directive({
    selector: '[appBackdropClose]'
})
export class BackdropCloseDirective {
    @Output() backdropClose = new EventEmitter<void>();
    private pressedOnBackdrop = false;

    @HostListener('mousedown', ['$event'])
    onMouseDown(event: MouseEvent) {
        this.pressedOnBackdrop = event.target === event.currentTarget;
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        if (this.pressedOnBackdrop && event.target === event.currentTarget) {
            this.backdropClose.emit();
        }
        this.pressedOnBackdrop = false;
    }
}
